const checkExpand = (currentRow, expandedList) => {
  const { expandTableIdentifier } = currentRow;
  if (!expandTableIdentifier) return true;
  return expandedList.includes(expandTableIdentifier);
};

export default checkExpand;
